import React from "react";

export const Products = (props) => {
    const [query, setQuery] = React.useState("");
    const [filteredProducts, setFilteredProducts] = React.useState([]);

    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    React.useEffect(() => {
        if (props.data) {
            setFilteredProducts(
                props.data.filter(product => product.name.toLowerCase().includes(query.toLowerCase()))
            );
        }
    }, [query, props.data]);

    return (
        <div id="all-products" className="text-center">
            <div className="container">
                <div className="section-title">
                    <h2>Produtos</h2>
                    <input
                        type="text"
                        placeholder="Procurar"
                        className="search"
                        onChange={e => setQuery(e.target.value)}
                    />
                    <p>{filteredProducts.length} produto(s) encontrado(s)</p>
                </div>
                <div className="row">
                    {props.data ? (
                        filteredProducts.length > 0 ? (
                            filteredProducts.map((d, i) => (
                                <div key={`${d.name}-${i}`} className="">
                                    <i className={d.icon}></i>
                                    <div className="service-desc">
                                        <h3>{d.name}</h3>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <p></p>
                        )
                    ) : (
                        "loading"
                    )}
                </div>
            </div>
        </div>
    );
};
